import * as React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
})

const TruncatedTextCell = ({ value }) => {
  const classes = useStyles()

  if (!value) {
    return <>—</>
  }

  return (
    <span className={classes.root} title={value}>
      {value}
    </span>
  )
}

TruncatedTextCell.propTypes = {
  value: PropTypes.string,
}

export default TruncatedTextCell
